import { bootstrap } from './bootstrap';

declare global {
  interface Window { 
    QUIZ_EMBED?: { 
      init: (opts?: { rootId?: string }) => void 
    }; 
  }
}

// Define the API
window.QUIZ_EMBED = {
  init: ({ rootId = 'quiz-root' } = {}) => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => bootstrap(rootId));
    } else {
      bootstrap(rootId);
    }
  }
};

// Auto-initialize on load if quiz-root element exists
const autoInit = () => {
  const quizRoot = document.getElementById('quiz-root');
  if (quizRoot) {
    bootstrap('quiz-root');
  }
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', autoInit);
} else {
  autoInit();
}
